// Utility to map managers to dropdown options
export function mapToManagerOptions(managers) {
  if (!Array.isArray(managers)) return [];
  return managers.map(m => ({
    value: m.sales_person_id,
    label: m.first_name + (m.last_name ? ` ${m.last_name}` : ''),
  }));
}
